export default {
   wame : 'https://wa.me/628176030030',
   // wame : 'https://wa.me/6281210105525',
   // sitekey : '6LcUwq8ZAAAAAKYxVzH-lkwndW9PH9jiBoTb5W-Y',
   sitekey : '6Lc2t74ZAAAAAIFNIaUJdGEcjS-RKJK3PjVMD9um',
   // baseApi: 'https://private-anon-24b0538ec1-tkon.apiary-mock.com',
   baseApi: 'https://xapi.tkon.id/api',
   // baseApi: 'https://dev.api.tkon.id/api',
   google: "6Lc2t74ZAAAAAIFNIaUJdGEcjS-RKJK3PjVMD9um",
   publicKey: `-----BEGIN RSA PUBLIC KEY-----
   MEgCQQDfT5vTsQ0wCA4/r0dix9KVR6SZRvO58XyAj7fjg+4+gk/FKYqCynsTd0gR
   CPuEtM+KXbOQSY6pPNiwH1y51Hi/AgMBAAE=
   -----END RSA PUBLIC KEY-----`,
   s3Host: 'https://cdn.tkon.id/whatsapp/'
}



// WEBPACK FOOTER //
// ./src/config.js